import React from 'react';
import { Users } from 'react-feather';

const EmptyState = () => {
  return (
    <div className="text-center my-5 py-5">
      <Users size={80} className="text-muted opacity-50 mb-3" />
      <h5 className="text-muted mb-2">Không tìm thấy người dùng</h5>
      <p className="text-muted">Thử thay đổi bộ lọc hoặc tìm kiếm</p>
    </div>
  );
};

export default EmptyState;

